"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Impersonate_exports = {};
__export(Impersonate_exports, {
  default: () => Impersonate_default
});
module.exports = __toCommonJS(Impersonate_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.62891 12.75C7.94141 12.75 8.22135 12.8281 8.46875 12.9844C8.72917 13.1406 8.93099 13.3424 9.07422 13.5898H11.9258C12.043 13.3815 12.1927 13.2057 12.375 13.0625C12.5703 12.9193 12.7917 12.8281 13.0391 12.7891C13.0911 12.776 13.1432 12.7695 13.1953 12.7695C13.2604 12.7565 13.319 12.75 13.3711 12.75H15.1289C15.5977 12.75 15.9948 12.9128 16.3203 13.2383C16.6458 13.5638 16.8086 13.9544 16.8086 14.4102C16.8086 14.4753 16.8021 14.5339 16.7891 14.5859C16.7891 14.638 16.7826 14.6901 16.7695 14.7422L16.5938 15.582C16.5156 15.9727 16.3203 16.2917 16.0078 16.5391C15.7083 16.7865 15.3633 16.9102 14.9727 16.9102H13.5273C13.1367 16.9102 12.7852 16.7865 12.4727 16.5391C12.1732 16.2917 11.9844 15.9727 11.9062 15.582L11.7305 14.7422C11.7174 14.6901 11.7044 14.638 11.6914 14.5859C11.6914 14.5208 11.6914 14.4622 11.6914 14.4102H9.30859C9.30859 14.4753 9.30208 14.5339 9.28906 14.5859C9.28906 14.638 9.28255 14.6901 9.26953 14.7422L9.09375 15.582C9.01562 15.9727 8.82031 16.2917 8.50781 16.5391C8.20833 16.7865 7.86328 16.9102 7.47266 16.9102H6.02734C5.63672 16.9102 5.28516 16.7865 4.97266 16.5391C4.67318 16.2917 4.48438 15.9727 4.40625 15.582L4.23047 14.7422C4.13932 14.2865 4.21745 13.8698 4.46484 13.4922C4.72526 13.1146 5.08333 12.8802 5.53906 12.7891C5.59115 12.776 5.64323 12.7695 5.69531 12.7695C5.76042 12.7565 5.81901 12.75 5.87109 12.75H7.62891ZM7.62891 13.5898H5.87109C5.84505 13.5898 5.8125 13.5898 5.77344 13.5898C5.7474 13.5898 5.72135 13.5898 5.69531 13.5898C5.48698 13.6419 5.31771 13.7526 5.1875 13.9219C5.07031 14.0911 5.01823 14.2799 5.03125 14.4883L5.05078 14.5859L5.20703 15.4062C5.24609 15.5885 5.33073 15.7448 5.46094 15.875C5.60417 15.9922 5.76042 16.0573 5.92969 16.0703L6.02734 16.0898H7.47266C7.65495 16.0898 7.81771 16.0378 7.96094 15.9336C8.10417 15.8164 8.20182 15.6732 8.25391 15.5039L8.29297 15.4062L8.44922 14.5859C8.44922 14.5599 8.44922 14.5339 8.44922 14.5078C8.46224 14.4688 8.46875 14.4362 8.46875 14.4102C8.46875 14.2018 8.39714 14.0195 8.25391 13.8633C8.11068 13.707 7.9349 13.6159 7.72656 13.5898H7.62891ZM15.1289 13.5898H13.3711C13.3451 13.5898 13.3125 13.5898 13.2734 13.5898C13.2474 13.5898 13.2214 13.5898 13.1953 13.5898C12.987 13.6419 12.8177 13.7526 12.6875 13.9219C12.5703 14.0911 12.5182 14.2799 12.5312 14.4883L12.5508 14.5859L12.707 15.4062C12.7461 15.5885 12.8307 15.7448 12.9609 15.875C13.1042 15.9922 13.2604 16.0573 13.4297 16.0703L13.5273 16.0898H14.9727C15.1549 16.0898 15.3177 16.0378 15.4609 15.9336C15.6042 15.8164 15.7018 15.6732 15.7539 15.5039L15.793 15.4062L15.9492 14.5859C15.9492 14.5599 15.9492 14.5339 15.9492 14.5078C15.9622 14.4688 15.9688 14.4362 15.9688 14.4102C15.9688 14.2018 15.8971 14.0195 15.7539 13.8633C15.6107 13.707 15.4349 13.6159 15.2266 13.5898H15.1289ZM12.9219 3.58984C13.4948 3.58984 14.0091 3.76562 14.4648 4.11719C14.9206 4.46875 15.2135 4.92448 15.3438 5.48438L16.125 8.58984H17.5898C17.9284 8.58984 18.2214 8.71354 18.4688 8.96094C18.7161 9.19531 18.8398 9.48828 18.8398 9.83984C18.8398 10.1784 18.7161 10.4714 18.4688 10.7188C18.2214 10.9661 17.9284 11.0898 17.5898 11.0898H3.41016C3.07161 11.0898 2.77865 10.9661 2.53125 10.7188C2.28385 10.4714 2.16016 10.1784 2.16016 9.83984C2.16016 9.48828 2.28385 9.19531 2.53125 8.96094C2.77865 8.71354 3.07161 8.58984 3.41016 8.58984H4.875L5.65625 5.48438C5.78646 4.92448 6.07943 4.46875 6.53516 4.11719C6.99089 3.76562 7.50521 3.58984 8.07812 3.58984H12.9219ZM12.9219 4.41016H8.07812C7.71354 4.41016 7.38802 4.52083 7.10156 4.74219C6.8151 4.95052 6.61328 5.21745 6.49609 5.54297L6.45703 5.67969L5.51953 9.41016H3.41016C3.29297 9.41016 3.19531 9.45573 3.11719 9.54688C3.03906 9.625 3 9.72266 3 9.83984C3 9.94401 3.03255 10.0352 3.09766 10.1133C3.16276 10.1784 3.24089 10.224 3.33203 10.25H3.41016H17.5898C17.707 10.25 17.8047 10.2109 17.8828 10.1328C17.9609 10.0547 18 9.95703 18 9.83984C18 9.73568 17.9674 9.64453 17.9023 9.56641C17.8372 9.48828 17.7591 9.44271 17.668 9.42969L17.5898 9.41016H15.4805L14.543 5.67969C14.4518 5.32812 14.2695 5.04167 13.9961 4.82031C13.7227 4.58594 13.4102 4.45573 13.0586 4.42969L12.9219 4.41016ZM5.5 7.75H15.5V9.41016H5.5V7.75Z",
      fill: "currentColor"
    }
  )
);
const SvgImpersonate = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Impersonate_default = SvgImpersonate;
